import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import JwtStore from '../flux/JwtStore';
import Card from '../components/Card';
import __ from '../utils/translator';
import PageHeader from '../components/PageHeader';
import CategoryStore from '../flux/CategoryStore';
import CategoryStoreActions from '../flux/CategoryStoreActions';
import CardTitle from '../components/CardTitle';
import ThemeCardThemeStatus from '../components/ThemeCardThemeStatus';
import flexColumns from '../utils/flexColumns';
import "../utils/randomInt";
import remToPixels from '../utils/remToPixels';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import ThemeLabelContainer
  from '../components/theme-card/ThemeLabelContainer';
import PageTitle from '../components/PageTitle';
import Header from '../components/organisms/Header';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import CardProgress from '../components/CardProgress';
import PatternCardList from '../components/PatternCardList';
import CardsLayoutPattern from '../utils/CardsLayoutPattern';
import OutletOnlyLabel from "../components/OutletOnlyLabel";

function resizeCover(cover) {
  return thronThumbnailResize(cover, {
    width: remToPixels(21),
    height: remToPixels(21)
  });
}

const defaultCategoryProps = {
  categoryName: null,
  categoryCover: null,
  themes: [],
};

function mapCategoryProps(category) {
  if (category === null) {
    return defaultCategoryProps;
  }

  return {
    categoryName: category.name,
    categoryCover: CategoryStore.getRandomCover(category),
    themes: category.themes,
  };
}

class Category extends Component {
  state = {
    didLoad: false,
    ...defaultCategoryProps
  };

  subscriptions = [];

  componentDidMount() {
    CategoryStoreActions.fetchById(this.props.match.params.categoryId);

    this.subscriptions.push(CategoryStore.addListener(() => {
      const category = CategoryStore.getState();

      this.setState({
        didLoad: category !== null,
        ...mapCategoryProps(category),
      });
    }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.categoryId !== this.props.match.params.categoryId) {
      CategoryStoreActions.fetchById(this.props.match.params.categoryId);
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <React.Fragment>
        <Header actions={themeResponsiveProperty(['back', 'search', 'glossary'], undefined)(this.props)} />

        {this.state.didLoad && (
          <PageTitle withTracking title={`Timeless / ${this.state.categoryName}`} />
        )}

        <PageHeader
          large
          crumbs={[__('Home'), __('Timeless'), this.state.categoryName]}
          cover={this.state.categoryCover}
          title={this.state.categoryName} />

        <Container>
          <ContainerInner>
            <PatternCardList pattern={CardsLayoutPattern.Grid}>
              {this.state.themes.map(theme => (
                <Card
                  key={theme.id}
                  linkTo={`/timeless/${theme.categoryId}/themes/${theme.id}`}
                  cover={resizeCover(theme.cover)}
                  justifyContent="flex-end"
                >
                  <ThemeLabelContainer theme={theme} />

                  <CardTitle
                    small={themeResponsiveProperty(false, true)(this.props)}
                    style={{ textTransform: 'uppercase', marginBottom: '.75rem' }}>
                    {theme.name}
                  </CardTitle>

                  <ThemeCardThemeStatus small status={theme.status} />
                  {theme.visibleOnlyForOutlets && <OutletOnlyLabel key="outlet_only" />}
                </Card>
              ))}
            </PatternCardList>
          </ContainerInner>
        </Container>
      </React.Fragment>
    );
  }
}

export default withTheme(Category);

const Container = styled.div`
  flex: 1;

  // @todo 2020-03-27 test new background color
  background-color: ${props => props.theme.primaryBackgroundColorNegative};
`;

const ContainerInner = styled.div`
  max-width: 64rem;
  margin-left: auto;
  margin-right: auto;
`;

const CategoryThemeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${({ columns }) => flexColumns(columns)};
  padding: .5rem;
`;

const CategoryCard = styled(Card)`
  // There might be some absolute positioned labels, therefore we need to set
  // position: relative.
  position: relative;

  height: 21rem;
  border: .25rem solid transparent;

  > div {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
`;
